import InitApi from "api/InitApi";
import ServerErrors from "components/SeverErrors";
import { useMutation, useQueryClient } from "react-query";
import { useHistory } from "react-router-dom";
import toast from "react-hot-toast";
import { reactLocalStorage } from "reactjs-localstorage";
import { deleteEmptyObjects } from "utils";
import useTokenStore from "store/tokenStore";

const useAssignBooksToUsers = () => {
	const queryClient = useQueryClient();
	const { accessToken } = useTokenStore();

	const history = useHistory();

	const save = async (obj) => {
		const instance = await InitApi({ accessToken });
		const body = deleteEmptyObjects(obj);
		const response = await instance.post(`/books/assign`, body);
		await queryClient.invalidateQueries(["books", "institution"]);
		await queryClient.invalidateQueries(["purchased", "my-library"]);
		return response.data;
	};

	return useMutation(save, {
		onSuccess: async (body) => {
			const failures = body?.data?.failures?.length || 0;
			toast.success(
				failures > 0
					? `${body.message}. ${failures} allocation(s) could not be completed.`
					: body.message
			);
		},
		onError: async (error) => {
			toast.error(
				<ServerErrors
					errorMessage={error?.response?.data?.message}
					errors={error?.response?.data?.data}
				/>,
				{
					className: "max-w-max",
				}
			);

			if (error?.response?.data.message === "Unauthenticated.") {
				reactLocalStorage.clear();
				history.push("/");
			}
		},
	});
};

export default useAssignBooksToUsers;
